module.exports = __webpack_public_path__ + "img/R04v.e1ca56f2.png";